import React from "react";
import {
  Row,
  Col,
  FormGroup,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroupAddon,
} from "reactstrap";

const TipInput = ({
  tipButtons,
  handleTipSelect,
  handleInputChange,
  tipAmountValue,
  dropdownOpen,
  currency,
  toggleDropdown,
  darkMode,
  color,
}) => {
  return (
    <Row className="d-flex flex-column mt-3">
      <Col className="d-flex flex-column justify-content-center align-items-center">
        <FormGroup style={{ maxWidth: "400px", width: "100%" }}>
          <InputGroup>
            <Input
              type="number"
              placeholder="Choose or enter a tip amount"
              value={tipAmountValue}
              min={0}
              onChange={handleInputChange}
              className="form-control"
              style={{
                backgroundColor: "#ffffff",
                color: darkMode ? "#000" : "#000",
                padding: "12px 20px",
                fontSize: "15px",
                border: "1px solid #ccc",
                borderRight: "none",
                borderRadius: "10px 0 0 10px",
                height: "46px",
              }}
            />
            <InputGroupAddon addonType="append">
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  caret
                  style={{
                    backgroundColor: color,
                    color: "#fff",
                    border: "1px solid transparent",
                    borderRadius: "0 10px 10px 0",
                    padding: "12px 20px",
                    fontSize: "15px",
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Tips
                </DropdownToggle>
                <DropdownMenu right>
                  {tipButtons &&
                    tipButtons.map((tip, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => handleTipSelect(tip, index)}
                      >
                        {currency || "$"}
                        {tip || ""}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </Dropdown>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default TipInput;
